import React from 'react';

/** Three soft dots that pulse in sequence — calm, not bouncy. */
export function TypingDots() {
  return <span className="inline-flex items-center gap-[3px] ml-1.5" aria-hidden="true" data-id="element-3445" data-mp="iwcu9kadgcs4">
      {[0, 1, 2].map(i => <span key={i} className={`typing-dot w-1 h-1 rounded-full ${i === 1 ? 'bg-[#6D5CF0]' : i === 2 ? 'bg-ai-purple' : 'bg-primary-indigo'}`} style={{
      animationDelay: `${i * 130}ms`
    }} data-id="element-3446" data-mp="wu1fit8cplxp" />)}
    </span>;
}